import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Zap, FileText } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="relative pt-32 pb-20 md:pt-40 md:pb-32 px-4 overflow-hidden bg-warm" data-id="element-97">
      {/* Background decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-98">
        <div className="absolute -top-[20%] -right-[10%] w-[70%] h-[70%] rounded-full bg-beige blur-3xl opacity-60" data-id="element-99" />
        <div className="absolute top-[40%] -left-[20%] w-[60%] h-[60%] rounded-full bg-highlight blur-3xl opacity-20" data-id="element-100" />
      </div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-101">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-102">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="text-center lg:text-left" data-id="element-103">
            <div className="inline-block mb-4 px-4 py-1.5 rounded-full bg-beige border border-border text-nude-dark font-medium text-sm tracking-wide" data-id="element-104">
              ⚡ +1.000 personas ya cambiaron su vida
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-primary leading-tight mb-4" data-id="element-105">
              Dejá de ser la misma persona que se promete cambiar cada lunes.
            </h1>

            <p className="text-2xl md:text-3xl text-cta italic font-serif mb-8" data-id="element-106">
              En 30 días, no te vas a reconocer.
            </p>

            <p className="text-lg md:text-xl text-secondary mb-8 leading-relaxed max-w-2xl mx-auto lg:mx-0" data-id="element-107">
              Con <strong data-id="element-108">Irreconocible en 30 Días</strong> vas a poder cambiar
              tus hábitos, tu mentalidad y tu físico paso a paso, incluso si hoy
              te cuesta ser constante, te falta energía o no sabés por dónde
              empezar.
            </p>

            <div className="flex flex-col items-center lg:items-start gap-6" data-id="element-109">
              <ul className="text-sm text-secondary space-y-1.5 text-center lg:text-left" data-id="element-110">
                <li data-id="element-111">🔐 Compra 100% segura con Mercado Pago</li>
                <li data-id="element-112">📩 Acceso inmediato luego del pago</li>
                <li data-id="element-113">‼️ Producto 100% digital (no se envía nada físico)</li>
                <li data-id="element-114">🧾 Los datos solicitados son solo para facturación</li>
                <li data-id="element-115">⭐️ +1.000 personas ya empezaron su transformación</li>
              </ul>

              <div className="w-full sm:w-auto relative" data-id="element-116">
                <div className="absolute -top-3 -right-3 sm:-right-6 bg-white border border-red-100 px-3 py-1 rounded-full shadow-lg flex items-center gap-2 z-10 animate-bounce" data-id="element-117">
                  <span className="w-2 h-2 rounded-full bg-red-500 animate-pulse" data-id="element-118"></span>
                  <span className="text-xs font-bold text-red-600 uppercase tracking-wider" data-id="element-119">
                    Oferta válida solo hoy
                  </span>
                </div>
                <CTAButton text="Acceder ahora (empezá hoy)" className="w-full sm:w-auto" data-id="element-120" />
              </div>
            </div>
          </motion.div>

          {/* Hero Image / Mockup */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative mx-auto w-full max-w-md lg:max-w-lg perspective-1000" data-id="element-121">
            {/* Ebook Cover Image */}
            <div className="relative w-full aspect-[3/4] rounded-2xl shadow-2xl overflow-hidden group" data-id="element-122">
              <img src="https://cdn.magicpatterns.com/uploads/6tcgXVxVHU8YrKSiRnZqDz/2B_2_BONOS_DE_REGALO.png" alt="Irreconocible en 30 Días - Portada del eBook" className="w-full h-full object-cover rounded-2xl transition-transform duration-500 group-hover:scale-105" data-id="element-123" />
              {/* Subtle overlay for depth */}
              <div className="absolute inset-0 rounded-2xl ring-1 ring-black/10 pointer-events-none" data-id="element-124"></div>
            </div>

            {/* Floating elements */}
            <motion.div animate={{
            y: [0, -10, 0]
          }} transition={{
            repeat: Infinity,
            duration: 3,
            ease: 'easeInOut'
          }} className="absolute -bottom-6 -right-6 bg-white p-4 rounded-xl shadow-soft border border-border flex items-center gap-3 z-20" data-id="element-125">
              <div className="bg-green-100 p-2 rounded-full" data-id="element-126">
                <svg className="w-5 h-5 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-127">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-128"></path>
                </svg>
              </div>
              <div className="text-sm font-bold text-primary" data-id="element-129">
                +1,000
                <br data-id="element-130" />
                <span className="text-xs font-normal text-secondary" data-id="element-131">
                  Vidas transformadas
                </span>
              </div>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>;
}